import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { KeyRound, Plus } from 'lucide-react';
import CopyableCode from '../shared/CopyableCode';
import ConnectInstructions from './ConnectInstructions';
import { PLATFORM_MCP_COPY } from '../../constants/platformMcpCopy';
import pageStyles from '../MyLLMKeys/MyLLMKeys.module.scss';
import styles from './PlatformMcp.module.scss';

/**
 * Server link, "Create connection key", and per-app instructions. Before a key
 * is created the instructions use the page's placeholder; after a create they
 * use that response's `connect` (kept in memory only, never re-fetchable).
 */
const ConnectTab = ({ status, data, created, loadError, onCreate, onRetry }) => {
  if (status === 'noAccess') {
    return <Alert severity="warning">{PLATFORM_MCP_COPY.noAccess}</Alert>;
  }
  if (status === 'error') {
    return (
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={onRetry}>
            Retry
          </Button>
        }
      >
        {loadError}
      </Alert>
    );
  }

  const liveConnect = created?.connect || null;
  const connect = liveConnect || data?.connect || null;
  const url = connect?.url || data?.url || null;

  return (
    <Box className={styles.tabBody}>
      {status === 'notReady' && <Alert severity="info">{PLATFORM_MCP_COPY.serverNotReady}</Alert>}

      <Box className={styles.card}>
        {url && (
          <CopyableCode
            label={PLATFORM_MCP_COPY.serverLink.toUpperCase()}
            tooltip={PLATFORM_MCP_COPY.serverLinkTip}
            value={url}
            ariaLabel="Copy server link"
          />
        )}
        <Box className={styles.createRow}>
          <Button
            variant="contained"
            className={pageStyles.primaryBtn}
            startIcon={<Plus size={16} />}
            onClick={onCreate}
          >
            {PLATFORM_MCP_COPY.createKey}
          </Button>
          <Typography variant="body2" className={styles.muted}>
            {PLATFORM_MCP_COPY.keyNameTip}
          </Typography>
        </Box>
      </Box>

      {connect && (
        <Box className={styles.card}>
          <Typography className={styles.cardTitle}>{PLATFORM_MCP_COPY.howToConnect}</Typography>
          {liveConnect ? (
            <Alert severity="success" icon={<KeyRound size={18} />}>
              {PLATFORM_MCP_COPY.filledInHint(created?.name)}
            </Alert>
          ) : (
            <Alert severity="info">{PLATFORM_MCP_COPY.placeholderHint}</Alert>
          )}
          <ConnectInstructions connect={connect} />
        </Box>
      )}
    </Box>
  );
};

export default ConnectTab;
